import { RectangleSkeleton } from '@/components/atoms/Skeleton';

export const TrendChartSkeleton = () => {
  return (
    <div className='flex flex-col gap-1'>
      {Array.from({ length: 3 })
        .fill(0)
        .map((key, index) => (
          <div className='flex justify-between' key={`skeleton-${index}`}>
            <div className='h-5 w-1/3'>
              <RectangleSkeleton height='100%' width='100%' />
            </div>
            <div className='h-5 w-1/3'>
              <RectangleSkeleton height='100%' width='100%' />
            </div>
          </div>
        ))}
      <div className='h-[64px] w-full'>
        <RectangleSkeleton />
      </div>
      <div className='flex justify-between'>
        <div className='mt-1 h-[15px] w-1/3'>
          <RectangleSkeleton height='100%' width='100%' />
        </div>
        <div className='mt-1 h-[15px] w-1/3'>
          <RectangleSkeleton height='100%' width='100%' />
        </div>
      </div>
    </div>
  );
};

export default TrendChartSkeleton;
